import { shipmentPtlShowValidate } from "../../application/dtos/shipment_ptl_show_validate";

export class shipmentPtlShowEntity {
    constructor({id, unique_order_number, shipment_number, shipping_service, total, shipping_price, invoice, total_weight, label_download, note_download, is_rfid, cod, created_at, client_id, box_id, consignee_id, charge, client, shipment_product_detail, order_status, consignee}){
        this.id = id;
        this.unique_order_number = unique_order_number; 
        this.shipment_number = shipment_number;
        this.shipping_service = shipping_service;
        this.total = total;
        this.shipping_price = shipping_price; 
        this.invoice = invoice;
        this.total_weight = total_weight;
        this.label_download = label_download;
        this.note_download = note_download;
        this.is_rfid = is_rfid;
        this.cod = cod;
        this.created_at = created_at;
        this.client_id = client_id;
        this.box_id = box_id;
        this.consignee_id = consignee_id;
        this.charge = charge;
        this.client = client;
        this.shipment_product_detail = shipment_product_detail;
        this.order_status = order_status;
        this.consignee = consignee;
    }

    isValid() {
        return shipmentPtlShowValidate(this);
    }
}